let page_schema = {
    "tiers": [
        {
            "name": "d-none",
            "type": "checkbox",
            "id": "d-nones",
            "class_name": "tags",
            "child_name": "d-none",
            "options": [
                {
                    "name": "Laboratory Equipment & Supplies",
                    "id": "laboratory-equipment-and-supplies"
                },
                {
                    "name": "Magnetic Beads & Spin Columns",
                    "id": "magnetic-beads-and-spin-columns"
                },
                {
                    "name": "Plastics",
                    "id": "plastics"
                },
                {
                    "name": "Devices & Instruments",
                    "id": "devices-and-instruments"
                },
                {
                    "name": "Lysis Tubes",
                    "id": "lysis-tubes"
                },
                {
                    "name": "96-Well Plates",
                    "id": "96-well-plates"
                },
                {
                    "name": "Tubes",
                    "id": "tubes"
                },
                {
                    "name": "Reservoirs",
                    "id": "reservoirs"
                },
                {
                    "name": "Magbeads",
                    "id": "magbeads"
                },
                {
                    "name": "Spin Columns",
                    "id": "spin-columns"
                },
                {
                    "name": "96-Well Spin Plates",
                    "id": "96-well-spin-plates"
                },
                {
                    "name": "Manual Homogenizers",
                    "id": "manual-homogenizers"
                },
                {
                    "name": "Homogenizers",
                    "id": "homogenizers"
                },
                {
                    "name": "Vortexers",
                    "id": "vortexers"
                },
                {
                    "name": "Vacuum Manifolds",
                    "id": "vacuum-manifolds"
                },
                {
                    "name": "Shakers",
                    "id": "shakers"
                },
                {
                    "name": "High-Throughput Solutions & Automation",
                    "id": "high-throughput-solutions-and-automation"
                },
                {
                    "name": "filters",
                    "id": "filters"
                }
            ]
        }
    ],
    "filters": [],
    "products": {
        "Quick-DNA 96 Plus Kit": {
            "title": "Quick-DNA 96 Plus Kit",
            "catalogNumbers": "D4070, D4071",
            "description": "High-throughput purification of high-quality total DNA from cells, tissues, and any biological fluid.",
            "handle": "/products/quick-dna-96-plus-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4071.jpg",
            "generalIndex": "998",
            "id": "quick-dna-96-plus-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA Magbead Plus Kit": {
            "title": "Quick-DNA Magbead Plus Kit",
            "catalogNumbers": "D4081, D4082",
            "description": "Automatable purification of high-quality total DNA from cells, tissues, and any biological fluid.",
            "handle": "/products/quick-dna-magbead-plus-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4081.jpg",
            "generalIndex": "998",
            "id": "quick-dna-magbead-plus-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZymoPURE 96 Plasmid Miniprep Kit": {
            "title": "ZymoPURE 96 Plasmid Miniprep Kit",
            "catalogNumbers": "D4214, D4215, D4216",
            "description": "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight <i>E. coli</i> culture using a vacuum or centrifuge.",
            "handle": "/products/zymopure-96-plasmid-miniprep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D4214_D4215_ZymoPURE96Kit.jpg?v=1688420296&width=600",
            "generalIndex": "998",
            "id": "zymopure-96-plasmid-miniprep-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 DNA Clean-Up Kit": {
            "title": "ZR-96 DNA Clean-Up Kit",
            "catalogNumbers": "D4017, D4018",
            "description": "High-throughput purification of up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources using a low-profile spin-plate.",
            "handle": "/products/zr-96-dna-clean-up-kit",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4017_ZR-96-DNA-Clean-up-Kit_1200x.jpg",
            "generalIndex": "998",
            "id": "zr-96-dna-clean-up-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 DNA Clean & Concentrator-5 (Deep Well)": {
            "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
            "catalogNumbers": "D4023, D4024",
            "description": "High-throughput purification of up to 5 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
            "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4023.webp",
            "generalIndex": "998",
            "id": "zr-96-dna-clean-amp-concentrator-5-deep-well",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "DNA Clean & Concentrator MagBead Kit": {
            "title": "DNA Clean & Concentrator MagBead Kit",
            "catalogNumbers": "D4012",
            "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
            "handle": "/products/dna-clean-concentrator-magbead-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4012.webp",
            "generalIndex": "998",
            "id": "dna-clean-concentrator-magbead-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 Zymoclean Gel DNA Recovery Kit": {
            "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
            "catalogNumbers": "D4021, D4022",
            "description": "High-throughput purification of highly concentrated ultra-pure DNA from TAE/TBE buffered agarose gels.",
            "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4021.webp",
            "generalIndex": "998",
            "id": "zr-96-zymoclean-gel-dna-recovery-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "OneStep PCR Inhibitor Removal Kit": {
            "title": "OneStep PCR Inhibitor Removal Kit",
            "catalogNumbers": "D6031, D6035",
            "description": "High-throughput removal of common PCR inhibitors from extracted DNA and RNA using a single step protocol.",
            "handle": "/products/onestep-pcr-inhibitor-removal-new-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6035.webp",
            "generalIndex": "998",
            "id": "onestep-pcr-inhibitor-removal-new-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZymoBIOMICS 96 DNA Kit": {
            "title": "ZymoBIOMICS 96 DNA Kit",
            "catalogNumbers": "D4303, D4307, D4309",
            "description": "High-throughput microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
            "handle": "/products/zymobiomics-96-dna-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4303.jpg",
            "generalIndex": "998",
            "id": "zymobiomics-96-dna-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZymoBIOMICS 96 MagBead DNA Kit": {
            "title": "ZymoBIOMICS 96 MagBead DNA Kit",
            "catalogNumbers": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
            "description": "Automatable solution for microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
            "handle": "/products/zymobiomics-96-magbead-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4302.jpg",
            "generalIndex": "998",
            "id": "zymobiomics-96-magbead-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA Fungal/Bacterial 96 Kit": {
            "title": "Quick-DNA Fungal/Bacterial 96 Kit",
            "catalogNumbers": "D6006",
            "description": "Simple high-throughput isolation of ultra-pure DNA from tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
            "handle": "/products/quick-dna-fungal-bacterial-96-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6006.jpg",
            "generalIndex": "998",
            "id": "quick-dna-fungal-bacterial-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA Fecal/Soil Microbe 96 Kit": {
            "title": "Quick-DNA Fecal/Soil Microbe 96 Kit",
            "catalogNumbers": "D6011",
            "description": "Robust high-throughput extraction of ultra-pure total microbial DNA from up to 80 mg of feces or 135 mg of soil.",
            "handle": "/products/quick-dna-fecal-soil-microbe-96-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6011.jpg",
            "generalIndex": "998",
            "id": "quick-dna-fecal-soil-microbe-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA Fecal/Soil Microbe 96 Magbead Kit": {
            "title": "Quick-DNA Fecal/Soil Microbe 96 Magbead Kit",
            "catalogNumbers": "D6010-FM, D6011-FM, D6012-FM",
            "description": "Robust automatable extraction of ultra-pure total microbial DNA from up to 100 mg of feces or 200 mg of soil.",
            "handle": "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6011_FM.jpg",
            "generalIndex": "998",
            "id": "quick-dna-fecal-soil-microbe-96-magbead-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "MAGicBead™ cfDNA Isolation Kit": {
            "title": "MAGicBead™ cfDNA Isolation Kit",
            "catalogNumbers": "D4086, D4086-custom",
            "description": "Unique, magnetic bead surface chemistry that facilitates unparalleled cfDNA recovery from biofluids.",
            "handle": "/products/magicbead-cfdna-isolation-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4086.jpg",
            "generalIndex": "998",
            "id": "magicbead-cfdna-isolation-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 Genomic DNA Clean & Concentrator-5 Kit": {
            "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
            "catalogNumbers": "D4066, D4067",
            "description": "High-throughput purification of up to 5 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation.",
            "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg?v=1628532355&width=600",
            "generalIndex": "998",
            "id": "zr-96-genomic-dna-clean-concentrator-5-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "<i>Quick</i>-DNA HMW MagBead Kit": {
            "title": "<i>Quick</i>-DNA HMW MagBead Kit",
            "catalogNumbers": "D6060",
            "description": "Extract ultra-pure high molecular weight DNA up to 150 kb from a variety of sample inputs using magnetic beads.",
            "handle": "/products/quick-dna-hmw-magbead-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6060.jpg",
            "generalIndex": "998",
            "id": "quick-dna-hmw-magbead-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 Oligo Clean & Concentrator Kit": {
            "title": "ZR-96 Oligo Clean & Concentrator Kit",
            "catalogNumbers": "D4062, D4063",
            "description": "High-throughput purification of up to 10 µg of highly concentrated DNA or RNA oligos from labeling and other enzymatic reactions.",
            "handle": "/products/oligo-clean-concentrator-zr96",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4062_ZR-96-Oligo-Clean-Concentrator.png?v=1628532356&width=600",
            "generalIndex": "998",
            "id": "oligo-clean-concentrator-zr96",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "<i>Quick</i>-DNA Plant/Seed 96 Kit": {
            "title": "<i>Quick</i>-DNA Plant/Seed 96 Kit",
            "catalogNumbers": "D6021",
            "description": "High-throughput isolation of high-quality DNA free of PCR inhibitors from tough-to-lyse plant and seed samples.",
            "handle": "/products/quick-dna-plant-seed-96-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6021.jpg",
            "generalIndex": "998",
            "id": "quick-dna-plant-seed-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "<i>Quick</i>-DNA Tissue/Insect 96 Kit": {
            "title": "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
            "catalogNumbers": "D6017",
            "description": "Simple high-throughput spin-column purification of high quality DNA from up to 10 mg of tissue or insect specimens.",
            "handle": "/products/quick-dna-tissue-insect-96-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/Insect_96_Kit.jpg",
            "generalIndex": "998",
            "id": "quick-dna-tissue-insect-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "<i>Quick</i>-DNA Viral 96 Kit": {
            "title": "<i>Quick</i>-DNA Viral 96 Kit",
            "catalogNumbers": "D3017, D3018",
            "description": "High-throughput extraction of highly concentrated ultra-pure viral DNA from a wide range of sample types.",
            "handle": "/products/quick-dna-viral-96-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3017.jpg",
            "generalIndex": "998",
            "id": "quick-dna-viral-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA 96 Kit": {
            "title": "Quick-DNA 96 Kit",
            "catalogNumbers": "D3010, D3011, D3012",
            "description": "High-throughput Proteinase K-free extraction of ultra-pure total DNA from 50 µl of blood or 1 x 10^6 cells.",
            "handle": "/products/quick-dna-96-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3012.jpg",
            "generalIndex": "998",
            "id": "quick-dna-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zyppy-96 Plasmid Kit": {
            "title": "Zyppy-96 Plasmid Kit",
            "catalogNumbers": "D4041, D4042, D4043",
            "description": "High-throughput purification of ultra-pure plasmid DNA from 750 µl of overnight <i>E. coli</i> culture without pelleting cells.",
            "handle": "/products/zyppy-96-plasmid-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4041.webp",
            "generalIndex": "998",
            "id": "zyppy-96-plasmid-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zyppy-96 Plasmid MagBead Miniprep Kit": {
            "title": "Zyppy-96 Plasmid MagBead Miniprep Kit",
            "catalogNumbers": "D4100, D4101, D4102",
            "description": "Automatable purification of ultra-pure plasmid DNA from 750 µl of overnight <i>E. coli</i> culture without pelleting cells.",
            "handle": "/products/zyppy-96-plasmid-magbead-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png?v=1628532412&width=600",
            "generalIndex": "998",
            "id": "zyppy-96-plasmid-magbead-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymoprep-96 Yeast Plasmid Miniprep Kit": {
            "title": "Zymoprep-96 Yeast Plasmid Miniprep Kit",
            "catalogNumbers": "D2005, D2006, D2007",
            "description": "Easy high-throughput spin-column purification of plasmid DNA from yeast cultures using Zymolyase and alkaline lysis.",
            "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit_815aae83-fc83-4806-8e72-654cdf122053.jpg?v=1628532360&width=600",
            "generalIndex": "998",
            "id": "zymoprep-96-yeast-plasmid-miniprep",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Select-a-Size DNA Clean & Concentrator Magbead Kit": {
            "title": "Select-a-Size DNA Clean & Concentrator Magbead Kit",
            "catalogNumbers": "D4084, D4085",
            "description": "Recover a specific size range of ultra-pure DNA fragments from library preps, PCR, and ligations using magnetic beads.",
            "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4084.webp",
            "generalIndex": "998",
            "id": "select-a-size-dna-clean-concentrator-magbead-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 ChIP DNA Clean & Concentrator Kit": {
            "title": "ZR-96 ChIP DNA Clean & Concentrator Kit",
            "catalogNumbers": "D5206, D5207",
            "description": "High-throughput recovery of ultra-pure DNA from any step in a standard ChIP protocol using rapid spin-column purification.",
            "handle": "/products/zr-96-chip-dna-clean-concentrator",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532406&width=600",
            "generalIndex": "998",
            "id": "zr-96-chip-dna-clean-concentrator",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 DNA Sequencing Clean-up Kit": {
            "title": "ZR-96 DNA Sequencing Clean-up Kit",
            "catalogNumbers": "D4052, D4053",
            "description": "High-throughput and rapid clean up of dye terminator sequencing reactions prior to Sanger Sequencing.",
            "handle": "/products/zr-96-dna-sequencing-clean-up-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4052.webp",
            "generalIndex": "998",
            "id": "zr-96-dna-sequencing-clean-up-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA/RNA MagBead Kit": {
            "title": "Quick-DNA/RNA MagBead Kit",
            "catalogNumbers": "R2130, R2131",
            "description": "A high-thoughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample.",
            "handle": "/products/quick-dna-rna-magbead",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2131-Quick-DNA-RNA-MagBead_9dd3abe5-e804-44ff-9faf-01cb95f36312.jpg?v=1628532371&width=600",
            "generalIndex": "998",
            "id": "quick-dna-rna-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Viral 96 Kit": {
            "title": "Quick-DNA/RNA Viral 96 Kit",
            "catalogNumbers": "D7022, D7023",
            "description": "High-throughput (96-well) isolation of high-quality viral DNA and/or RNA from a wide range of biological sources. ",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-96-kit",
            "navigation_image": "quick_dna_rna_viral_96",
            "generalIndex": "998",
            "id": "quick-dna-rna-viral-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Viral MagBead Kit": {
            "title": "Quick-DNA/RNA Viral MagBead Kit",
            "catalogNumbers": "R2140, R2140-E, R2141, R2141-E",
            "description": "High-throughput, magnetic bead-based purification of viral DNA and/or RNA from plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, biopsies and swab and fecal samples stored in DNA/RNA Shield.",
            "handle": "/products/quick-dna-rna-viral-magbead",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2140-quick-dna-rna-viral-magbead-ce-ivd.jpg?v=1628532376&width=600",
            "generalIndex": "998",
            "id": "quick-dna-rna-viral-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Load N' Go DNA/RNA Viral Kit": {
            "title": "Load N' Go DNA/RNA Viral Kit",
            "catalogNumbers": "R2143",
            "description": "Pre-loaded laboratory automation-ready reagent plates",
            "handle": "/products/load-n-go-dna-rna-viral-kit",
            "navigation_image": "quick_dna_rna_viral_magbead",
            "generalIndex": "998",
            "id": "load-n-go-dna-rna-viral-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA/RNA HT Kit": {
            "title": "Quick-DNA/RNA HT Kit",
            "catalogNumbers": "R2150, R2150-E, R2151, R2151-E",
            "description": "The Quick-DNA/RNA HT kit is intended for rapid, high-throughput nucleic acid extraction (automated or manual) from any biological or clinical sample.",
            "handle": "/products/quick-dna-rna-ht",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/LowResProductImage-R2150-E_-R2151-E-Quick-DNA-RNA-HT_Dx_1200x.jpg",
            "generalIndex": "998",
            "id": "quick-dna-rna-ht",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZymoBIOMICS MagBead DNA/RNA Kit": {
            "title": "ZymoBIOMICS MagBead DNA/RNA Kit",
            "catalogNumbers": "R2135, R2136",
            "description": "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
            "handle": "/products/zymobiomics-magbead-dna-rna",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2135_zymobiomics_96_magbead_dna_rna_kit.png?v=1628532421&width=600",
            "generalIndex": "998",
            "id": "zymobiomics-magbead-dna-rna",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Pathogen MagBead Kit": {
            "title": "Quick-DNA/RNA Pathogen MagBead Kit",
            "catalogNumbers": "R2145, R2146",
            "description": "High-throughput, magnetic bead-based purification of pathogen (virus, bacteria, protozoa) DNA and RNA from a wide variety of vectors (mosquitoes, fleas, ticks, etc.)",
            "handle": "/products/quick-dna-rna-pathogen-magbead",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg?v=1628532370&width=600",
            "generalIndex": "998",
            "id": "quick-dna-rna-pathogen-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Direct-zol-96 RNA Kits": {
            "title": "Direct-zol-96 RNA Kits",
            "catalogNumbers": "R2054, R2055, R2056, R2057",
            "description": "High-throughput (96-well) isolation of high-quality RNA directly from samples in TRI Reagent&reg and similar without phase separation.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-96-rna-kits",
            "navigation_image": "high_throughput_magbead_tri",
            "generalIndex": "998",
            "id": "direct-zol-96-rna-kits",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Direct-zol-96 MagBead RNA": {
            "title": "Direct-zol-96 MagBead RNA",
            "catalogNumbers": "R2100, R2101, R2102, R2103",
            "description": "High-throughput (96-well), magnetic bead-based isolation of high-quality RNA directly from samples in TRI Reagent&reg and similar without phase separation.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-96-magbead-rna",
            "navigation_image": "high_throughput_magbead_tri",
            "generalIndex": "998",
            "id": "direct-zol-96-magbead-rna",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-RNA MagBead": {
            "title": "Quick-RNA MagBead",
            "catalogNumbers": "R2132, R2133",
            "description": "High-throughput magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
            "handle": "/collections/quick-rna-kits/products/quick-rna-magbead",
            "navigation_image": "quick_rna_magbead",
            "generalIndex": "998",
            "id": "quick-rna-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-RNA 96 Kit": {
            "title": "Quick-RNA 96 Kit",
            "catalogNumbers": "R1052, R1053",
            "description": "Innovative, high-throughput (96-well) RNA isolation kits designed for rapid isolation of high quality, DNA-free, total RNA from a wide range of cell and tissue samples.",
            "handle": "/collections/quick-rna-kits/products/quick-rna-96-kit",
            "navigation_image": "quick_rna_96",
            "generalIndex": "998",
            "id": "quick-rna-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-DNA/RNA MagBead": {
            "title": "Quick-DNA/RNA MagBead",
            "catalogNumbers": "R2130, R2131",
            "description": "A high-throughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-magbead",
            "navigation_image": "quick_dna_rna_magbead",
            "generalIndex": "998",
            "id": "quick-dna-rna-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-RNA Viral 96 Kit": {
            "title": "Quick-RNA Viral 96 Kit",
            "catalogNumbers": "R1040, R1040-E, R1041, R1041-E",
            "description": "High-throughput (96-well) isolation of high-quality viral RNA from a wide range of biological sources. ",
            "handle": "/collections/quick-rna-viral-kits/products/quick-rna-viral-96-kit",
            "navigation_image": "quick_dna_rna_viral_96",
            "generalIndex": "998",
            "id": "quick-rna-viral-96-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZymoBIOMICS MagBead RNA": {
            "title": "ZymoBIOMICS MagBead RNA",
            "catalogNumbers": "R2137, R2138",
            "description": "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
            "handle": "/collections/zymobiomics-rna-kits/products/zymobiomics-magbead-rna",
            "navigation_image": "high_throughput_magbead_microbiomics",
            "generalIndex": "998",
            "id": "zymobiomics-magbead-rna",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "RNA Clean & Concentrator-96": {
            "title": "RNA Clean & Concentrator-96",
            "catalogNumbers": "R1080",
            "description": "RNA clean up kit that provides a simple and reliable method for high-throughput (96-well plate) preparation of high-quality, RT-PCR-ready RNA (up to 10 µg per well).",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-96",
            "navigation_image": "rna_clean_96",
            "generalIndex": "998",
            "id": "rna-clean-concentrator-96",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "RNA Clean & Concentrator MagBead": {
            "title": "RNA Clean & Concentrator MagBead",
            "catalogNumbers": "R1081, R1082",
            "description": "Simple and reliable high-throughput (magnetic bead-based) method for the rapid preparation of high-quality, DNA-free RNA.",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-magbead",
            "navigation_image": "rna_clean_magbead",
            "generalIndex": "998",
            "id": "rna-clean-concentrator-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZR-96 Oligo Clean & Concentrator": {
            "title": "ZR-96 Oligo Clean & Concentrator",
            "catalogNumbers": "D4062, D4063",
            "description": "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
            "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator-zr96",
            "navigation_image": "high_throughput_96_well_oligo_clean",
            "generalIndex": "998",
            "id": "oligo-clean-concentrator-zr96",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation Kit": {
            "title": "EZ-96 DNA Methylation Kit",
            "catalogNumbers": "D5003, D5004",
            "description": "Streamlined bisulfite treatment of DNA in a 96-well plate.",
            "handle": "/products/ez-96-dna-methylation-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5003-EZ-96-DNA-Methylation-Kit---shallow-well.png?v=1628532406&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation-Gold Kit": {
            "title": "EZ-96 DNA Methylation-Gold Kit",
            "catalogNumbers": "D5007, D5008",
            "description": "Complete bisulfite conversion of DNA in a 96-well plate in less than 3 hours.",
            "handle": "/products/ez-96-dna-methylation-gold-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5007_EZ-DNA-Methylation-Gold-Kit.jpg?v=1628532400&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-gold-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation-Direct Kit": {
            "title": "EZ-96 DNA Methylation-Direct Kit",
            "catalogNumbers": "D5022, D5023 ",
            "description": "A complete and reliable bisulfite conversion kit that eliminates cumbersome DNA precipitation steps and allows DNA bisulfite conversion directly…",
            "handle": "/products/ez-96-dna-methylation-direct-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5022_EZ-96-DNA-Methylatoin-Direct-Kit-Shallow-Well.jpg?v=1628532411&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-direct-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation-Lightning Kit": {
            "title": "EZ-96 DNA Methylation-Lightning Kit",
            "catalogNumbers": "D5032, D5033",
            "description": "Fastest method for bisulfite conversion of DNA paired with purification on a 96-well plate for high-throughput sample processing.",
            "handle": "/products/ez-96-dna-methylation-lightning-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well_8a88a685-b5c4-48bd-a549-d70384045426.jpg?v=1632268109&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-lightning-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation MagPrep": {
            "title": "EZ-96 DNA Methylation MagPrep",
            "catalogNumbers": "D5040, D5041",
            "description": "Streamlined bisulfite treatment of DNA.",
            "handle": "/products/ez-96-dna-methylation-magprep",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg?v=1628532410&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-magprep",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation-Gold MagPrep": {
            "title": "EZ-96 DNA Methylation-Gold MagPrep",
            "catalogNumbers": "D5042, D5043",
            "description": "The EZ-96 DNA Methylation-Gold MagPrep integrates DNA denaturation and bisulfite conversion processes into one step coupled to a magnetic bead-based…",
            "handle": "/products/ez-96-dna-methylation-gold-magprep",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg?v=1628532384&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-gold-magprep",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation-Direct MagPrep": {
            "title": "EZ-96 DNA Methylation-Direct MagPrep",
            "catalogNumbers": "D5044, D5045",
            "description": "A complete and reliable bisulfite conversion kit that eliminates cumbersome DNA precipitation steps and allows DNA bisulfite conversion directly…",
            "handle": "/products/ez-96-dna-methylation-direct-magprep",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5044-EZ-96-Methylation-Lightning-Direct.jpg?v=1628532392&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-direct-magprep",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "EZ-96 DNA Methylation-Lightning MagPrep": {
            "title": "EZ-96 DNA Methylation-Lightning MagPrep",
            "catalogNumbers": "D5046, D5047",
            "description": "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
            "handle": "/products/ez-96-dna-methylation-lightning-magprep",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5046-E_EZ-96-DNA-Methylation-Lightning-MagPrep_4e8e4b9b-86d1-4c0f-bce8-abe88db4135a.jpg?v=1676054453&width=600",
            "generalIndex": "998",
            "id": "ez-96-dna-methylation-lightning-magprep",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq SwitchFree 3′ mRNA Library Kit": {
            "title": "Zymo-Seq SwitchFree 3′ mRNA Library Kit",
            "catalogNumbers": "R3008, R3009",
            "description": "UMI-integrated, simple 3′ mRNA library preparation in ~4 hours with scalable sample multiplexing suitable for high-throughput protein coding gene counting.",
            "handle": "/products/zymo-seq-switchfree-3-mrna-library-kit",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/R3008Zymo-SeqSwitchFree3_mRNALibraryKit_1_5760x5760.jpg",
            "generalIndex": "998",
            "id": "zymo-seq-switchfree-3-mrna-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq RiboFree Total RNA Library Kit": {
            "title": "Zymo-Seq RiboFree Total RNA Library Kit",
            "catalogNumbers": "R3000, R3003",
            "description": "One for all. Simplest and all-inclusive total RNA-Seq library preparation kit with universal rRNA depletion for any organism.",
            "handle": "/products/zymo-seq-ribofree-total-rna-library-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/R3000Zymo-SeqRiboFreeTotalRNALibraryKit.jpg?v=1686677245&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-ribofree-total-rna-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq RiboFree Universal cDNA Kit": {
            "title": "Zymo-Seq RiboFree Universal cDNA Kit",
            "catalogNumbers": "R3001",
            "description": "Simplest NGS-Grade cDNA kit with universal rRNA depletion for any organism.",
            "handle": "/products/zymo-seq-ribofree-universal-cdna-kit?",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/Zymo-SeqRiboFreeUniversalcDNAKit_Custom.jpg?v=1686690637&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-ribofree-universal-cdna-kit?",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq UDI Primer Sets": {
            "title": "Zymo-Seq UDI Primer Sets",
            "catalogNumbers": "D3008, D3096, D3097, D3098",
            "description": "Can barcode any library containing TruSeq<sup>®</sup> adapters. Now available in a 10-bp format for multiplexing up to 192 libraries.",
            "handle": "/products/zymo-seq-udi-primer-sets?",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d3008_d3096_zymo-seq_udi_primer_set_Indexes_1-96.png?v=1628532421&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-udi-primer-sets?",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq Trio WGBS Library Kit": {
            "title": "Zymo-Seq Trio WGBS Library Kit",
            "catalogNumbers": "D5462, D5463",
            "description": "The Zymo-Seq Trio WGBS Library Kit offers an optimized and reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation from cell-free DNA (cfDNA), FFPE DNA, and gDNA. ",
            "handle": "/products/zymo-seq-trio-wgbs-library-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg?v=1642623540&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-trio-wgbs-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq WGBS Library Kit": {
            "title": "Zymo-Seq WGBS Library Kit",
            "catalogNumbers": "D5465",
            "description": "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. The Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-up steps required by…",
            "handle": "/products/zymo-seq-wgbs-library-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5465-zymo_seq_wgbs_library_kit.jpg?v=1628632445&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-wgbs-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq RRBS Library Kit": {
            "title": "Zymo-Seq RRBS Library Kit",
            "catalogNumbers": "D5460, D5461",
            "description": "Zymo-Seq RRBS Library Kit is an all-in-one RRBS library prep kit that generates NGS libraries with a simplified workflow for the classic method Reduced Representation Bisulfite Sequencing (RRBS). This all-in-one RRBS library prep kit allows for DNA methylation...",
            "handle": "/products/zymo-seq-rrbs-library-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5460_ez_dna_methylation_rrbs_library_prep_kit_3045e660-6901-4f39-bdf2-0a00421995b9.png?v=1628706203&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-rrbs-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Pico Methyl-Seq Library Prep Kit": {
            "title": "Pico Methyl-Seq Library Prep Kit",
            "catalogNumbers": "D5455, D5456",
            "description": "The Pico Methyl-Seq Library Prep Kit provides a streamlined workflow for making WGBS libraries. Input DNA is randomly fragmented during the initial bisulfite treatment step followed by three rounds of amplification with uniquely designed primers. The...",
            "handle": "/products/pico-methyl-seq-library-prep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5456_pico-methyl-seq-library-prep-kit_1.jpg?v=1628532385&width=600",
            "generalIndex": "998",
            "id": "pico-methyl-seq-library-prep-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "RRHP 5-hmC Library Prep Kit": {
            "title": "RRHP 5-hmC Library Prep Kit",
            "catalogNumbers": "D5450, D5451",
            "description": "The RRHP 5-hmC Library Prep Kit is an all-inclusive solution for analysis of genome-wide 5-hydroxymethylcytosine (5-hmC) positions at single-base resolution. The Reduced Representation Hydroxymethylation Profiling (RRHP) method is based on blocking MspI...",
            "handle": "/products/rrhp-5-hmc-library-prep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5450_RRHP_205-hmC_20Library_20Prep_20Kit.png?v=1628532403&width=600",
            "generalIndex": "998",
            "id": "rrhp-5-hmc-library-prep-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq ATAC Library Kit": {
            "title": "Zymo-Seq ATAC Library Kit",
            "catalogNumbers": "D5458",
            "description": "Zymo-Seq ATAC Library Kit provides a simple and streamlined workflow for Assay for Transposase Accessible Chromatin with high throughput Sequencing (ATAC-Seq) library preparation from mammalian cell and tissue input. This all-inclusive kit features an…",
            "handle": "/products/zymo-seq-atac-library-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto.jpg?v=1677624838&width=600",
            "generalIndex": "998",
            "id": "zymo-seq-atac-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Zymo-Seq SPLAT DNA Library Kit": {
            "title": "Zymo-Seq SPLAT DNA Library Kit",
            "catalogNumbers": "D5464",
            "description": "The Zymo-Seq™ SPLAT DNA Library Kit is a versatile solution for DNA library preparation from a wide variety of sample types. ",
            "handle": "/products/zymo-seq-splat-dna-library-kit",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/d5464_zymo-seq_splat_dna_library_kit__12_prep_5760x5760.webp",
            "generalIndex": "998",
            "id": "zymo-seq-splat-dna-library-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-16S NGS Library Prep Kit": {
            "title": "Quick-16S NGS Library Prep Kit",
            "catalogNumbers": "D6400",
            "description": "Microbial composition profiling techniques powered by Next-Generation sequencing are becoming routine in microbiomics and metagenomics studies. However, these analytical techniques can suffer from significant bias from collection to analysis. The ZymoBIOMICS...",
            "handle": "/products/quick-16s-ngs-library-prep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6400_Quick-16S_20NGS_20Library_20Prep_20Kit.png?v=1628532355&width=600",
            "generalIndex": "998",
            "id": "quick-16s-ngs-library-prep-kit",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-16S Plus NGS Library Prep Kit (V4)": {
            "title": "Quick-16S Plus NGS Library Prep Kit (V4)",
            "catalogNumbers": "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
            "description": "The Quick-16S Plus NGS Library Prep Kit (V4) is the fastest and simplest NGS library prep targeting the V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a premixed amplification plate and a single…",
            "handle": "/products/quick-16s-plus-ngs-library-prep-kit-v4",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg?v=1658345576&width=600",
            "generalIndex": "998",
            "id": "quick-16s-plus-ngs-library-prep-kit-v4",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-ITS Plus NGS Library Prep Kit (UDI)": {
            "title": "Quick-ITS Plus NGS Library Prep Kit (UDI)",
            "catalogNumbers": "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
            "description": "Quick-ITS Plus NGS Library Prep Kit (UDI) is the fastest and simplest NGS library prep targeting the ITS region for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode…",
            "handle": "/products/quick-its-plus-ngs-library-prep-kit-udi",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/d6425-quick_its_plus_ngs_library_prep_kit_5760x5760_14553474-0b99-4d23-a38a-702f249f7793_5760x5760.webp",
            "generalIndex": "998",
            "id": "quick-its-plus-ngs-library-prep-kit-udi",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI)": {
            "title": "Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
            "catalogNumbers": "D6421-PS1, D6421-PS2, D6421-PS3, D6421-PS4, D6421-PS5, D6421-PS6, D6421-PS7, D6421-PS8",
            "description": "The Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep targeting the V3-V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined…",
            "handle": "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/d6420-quick_16s_plus_ngs_library_prep_kit_5760x5760_b92f8884-354d-48bf-9660-e41bd948cd3f.jpg?v=1690506528&width=600",
            "generalIndex": "998",
            "id": "quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-16S Plus NGS Library Prep Kit (V1-V2)": {
            "title": "Quick-16S Plus NGS Library Prep Kit (V1-V2)",
            "catalogNumbers": "D6434-PS1",
            "description": "The Quick-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep targeting the V1-V2 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted...",
            "handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D6434Quick-16SNGSLibraryPrepKit_V1-V2_5760x5760.jpg",
            "generalIndex": "998",
            "id": "quick-16s-plus-ngs-library-prep-kit-v1-v2",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-16S Plus NGS Library Prep Kit (V1-V3)": {
            "title": "Quick-16S Plus NGS Library Prep Kit (V1-V3)",
            "catalogNumbers": "D6440-PS1, D6440-PS2, D6440-PS3, D6440-PS4",
            "description": "The Quick-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep targeting the V1-V3 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted...",
            "handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D6440Quick-16SNGSLibraryPrepKit_V1-V3_5760x5760.jpg",
            "generalIndex": "998",
            "id": "quick-16s-plus-ngs-library-prep-kit-v1-v3",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "Quick-16S/ITS NGS Library Prep Kit Sampler": {
            "title": "Quick-16S/ITS NGS Library Prep Kit Sampler",
            "catalogNumbers": "D6499",
            "description": "The Quick-16S/ITS™ NGS Library Prep Sampler provides 8 reactions from each of our Quick-16S/ITS™ Plus library prep kits as well as our Quick -16S™ Full-Length Library Prep Kit. Sample the Microbiomics library prep kit portfolio in one convenient format.",
            "handle": "/products/quick-16s-its-ngs-library-prep-sampler",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/ASP01770_copy_-_Copy_5760x5760.webp",
            "generalIndex": "998",
            "id": "quick-16s-its-ngs-library-prep-sampler",
            "tags": [
                "laboratory-equipment-and-supplies",
                "high-throughput-solutions-and-automation"
            ],
            "filters": []
        },
        "ZymoPURE Filter Plate": {
            "title": "ZymoPURE Filter Plate",
            "catalogNumbers": "C2022",
            "description": "High-throughput clarification of bacterial lysates.",
            "handle": "/products/zymopure-filter-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/C2022_ZymoPURE-Filter-Plate.jpg?v=1689111679&width=600",
            "generalIndex": "998",
            "id": "zymopure-filter-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Zymo-Spin P-96 Plate": {
            "title": "Zymo-Spin P-96 Plate",
            "catalogNumbers": "C2023",
            "description": "High-throughput plasmid DNA purification spin-plate.",
            "handle": "/products/zymo-spin-p-96-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/C2023_Zymo-Spin-P-96-Plate.jpg?v=1689111710&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-p-96-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Wash Plate": {
            "title": "Wash Plate",
            "catalogNumbers": "C2024, C2024-1",
            "description": "96-well plate for minimizing cross-contamination during high-throughput processing.",
            "handle": "/products/wash-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/C2024_Wash-Plate.jpg?v=1689111737&width=600",
            "generalIndex": "998",
            "id": "wash-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "96-Well 2.0 mL Deep Well Plate": {
            "title": "96-Well 2.0 mL Deep Well Plate",
            "catalogNumbers": "C2015, C2015-50",
            "description": "96-Well Plate for Liquid Handling Robots",
            "handle": "/products/96-well-deep-well-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2015-2_96-Well-2.0-ml-Deep-Well-Plate_4c243775-777b-4099-9f1c-3ef84cebdaaf.jpg?v=1680798370&width=600",
            "generalIndex": "998",
            "id": "96-well-deep-well-plate",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "96 Elution Plate (V-Bottom, 200 µL)": {
            "title": "96 Elution Plate (V-Bottom, 200 µL)",
            "catalogNumbers": "C1030, C1030-50",
            "description": "96-Well Polypropylene Elution Plate for Magnetic Bead Moving Instruments",
            "handle": "/products/96-elution-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1030_ZRC_2151.jpg?v=1678914807&width=600",
            "generalIndex": "998",
            "id": "96-elution-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-plates"
            ],
            "filters": []
        },
        "96 Deep Well Plate (V-Bottom, 2.2ml)": {
            "title": "96 Deep Well Plate (V-Bottom, 2.2ml)",
            "catalogNumbers": "C2018-5, C2018-50",
            "description": "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
            "handle": "/products/96-deep-well-plate-v-bottom-2-2ml",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2018_ZRC_2164.jpg?v=1672792995&width=600",
            "generalIndex": "998",
            "id": "96-deep-well-plate-v-bottom-2-2ml",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "96 Tip Combs (For V-Bottom Deep Well Plate)": {
            "title": "96 Tip Combs (For V-Bottom Deep Well Plate)",
            "catalogNumbers": "C2019, C2019-100",
            "description": "96 Tip Comb for Magnetic Bead Moving Instruments",
            "handle": "/products/96-tip-combs-for-v-bottom-deep-well-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2019_ZRC_2146.jpg?v=1672854572&width=600",
            "generalIndex": "998",
            "id": "96-tip-combs-for-v-bottom-deep-well-plate",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "Zymo-Spin I Columns": {
            "title": "Zymo-Spin I Columns",
            "catalogNumbers": "C1003-250, C1003-50",
            "description": "Uncapped columns bind up to 5 µg DNA or 10 µg RNA in ≥ 6 µl.",
            "handle": "/products/zymo-spin-i-columns",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/C1003-Zymo-Spin-I_4990ad19-f060-4bf3-8e05-bef4fc795479_600x.jpg?v=1605737865",
            "generalIndex": "998",
            "id": "zymo-spin-i-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IC Columns": {
            "title": "Zymo-Spin IC Columns",
            "catalogNumbers": "C1004-250, C1004-50",
            "description": "Capped columns bind up to 5 µg DNA or 10 µg RNA in ≥ 6 µl.",
            "handle": "/products/zymo-spin-ic-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1004-Zymo-Spin-IC.jpg?v=1628532397&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ic-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IC-XL": {
            "title": "Zymo-Spin IC-XL",
            "catalogNumbers": "C1002-25, C1002-50",
            "description": "Capped columns for the recovery of large-sized DNA in ≥ 10 µl.",
            "handle": "/products/zymo-spin-ic-xl",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1002-50-Zymo-Spin-IC-XL.jpg?v=1628532400&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ic-xl",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IC-XM Columns": {
            "title": "Zymo-Spin IC-XM Columns",
            "catalogNumbers": "C1103-50",
            "description": "The Zymo-Spin IC-XM column can be used on microcentrifuges for the purification of high molecular weight DNA and/or RNA.",
            "handle": "/products/zymo-spin-ic-xm-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1103-50_Zymo-Spin_20IC-XM_20Column.png?v=1628532389&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ic-xm-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IC-S Columns": {
            "title": "Zymo-Spin IC-S Columns",
            "catalogNumbers": "C1015-25, C1015-50",
            "description": "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
            "handle": "/products/zymo-spin-ic-s-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1015-50-Zymo-Spin-IC-S.jpg?v=1628532392&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ic-s-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IB Columns": {
            "title": "Zymo-Spin IB Columns",
            "catalogNumbers": "C1014-250, C1014-50",
            "description": "Columns for nucleic acid purification and dye removal.",
            "handle": "/products/zymo-spin-ib-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1014-Zymo-Spin-IB.jpg?v=1628532400&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ib-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin P1 Columns": {
            "title": "Zymo-Spin P1 Columns",
            "catalogNumbers": "P2003-1",
            "description": "Columns for purification of His-tagged proteins.",
            "handle": "/products/zymo-spin-p1-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/zymo-spin_pi_c2003-1.png?v=1628532396&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-p1-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin II Columns": {
            "title": "Zymo-Spin II Columns",
            "catalogNumbers": "C1008-250, C1008-50",
            "description": "Uncapped columns for the recovery of ≤ 25 µg DNA in ≥ 25 µl.",
            "handle": "/products/zymo-spin-ii-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1008-50-Zymo-Spin-II.jpg?v=1628532407&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ii-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IIC Columns": {
            "title": "Zymo-Spin IIC Columns",
            "catalogNumbers": "C1011-250, C1011-50",
            "description": "Capped columns for the recovery of DNA and RNA in ≥ 25 µl.",
            "handle": "/products/zymo-spin-iic-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/c1011-50-zymo-spin-iic.png?v=1628532408&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iic-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IIN Columns": {
            "title": "Zymo-Spin IIN Columns",
            "catalogNumbers": "C1019-250, C1019-50",
            "description": "Uncapped columns for the recovery of ≤ 25 µg DNA in ≥ 30 µl.",
            "handle": "/products/zymo-spin-iin-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1019-Zymo-Spin-IIN.jpg?v=1628532389&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iin-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin II-µHRC Filters": {
            "title": "Zymo-Spin II-µHRC Filters",
            "catalogNumbers": "C1059-50",
            "description": "For use with Zymo Research DNA and RNA purification kits.",
            "handle": "/products/zymo-spin-ii-%C2%B5hrc-filters",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1059_Zymo_20Spin_20II-HRC.png?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ii-%C2%B5hrc-filters",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "Zymo-Spin II-P Columns": {
            "title": "Zymo-Spin II-P Columns",
            "catalogNumbers": "C1055-50",
            "description": "Compatible on a microcentrifuge or vacuum manifold for the purification of plasmid DNA.",
            "handle": "/products/zymo-spin-ii-p-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1055-50_Zymo-Spin_20II-P_20Column.png?v=1628532400&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ii-p-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin III Columns": {
            "title": "Zymo-Spin III Columns",
            "catalogNumbers": "C1005-50, C1005-250",
            "description": "The Zymo-Spin III Fast-Spin column can be used either in microcentrifuges or on vacuum manifolds for the purification of DNA and/or RNA.",
            "handle": "/products/zymo-spin-iii-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1005-Zymo-Spin-III.jpg?v=1628532396&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iii-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin IIICG Columns": {
            "title": "Zymo-Spin IIICG Columns",
            "catalogNumbers": "C1006-50-G, C1006-250-G",
            "description": "Capped version of the Zymo-Spin III column with a green retention ring.",
            "handle": "/products/zymo-spin-iiicg-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1006-50-G-Zymo-Spin-IIICG.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iiicg-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin III-F Filters": {
            "title": "Zymo-Spin III-F Filters",
            "catalogNumbers": "C1057-50",
            "description": "For use with Zymo Research DNA and RNA purification kits.",
            "handle": "/products/zymo-spin-iii-f-filters",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1057-Zymo-Spin-III-F.jpg?v=1628532408&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iii-f-filters",
            "tags": [
                "laboratory-equipment-and-supplies",
                "filters"
            ],
            "filters": []
        },
        "Zymo-Spin III-HRC Filters": {
            "title": "Zymo-Spin III-HRC Filters",
            "catalogNumbers": "C1058-50",
            "description": "Component used in the OneStep< PCR Inhibitor Removal kit (Cat. #D6030).",
            "handle": "/products/zymo-spin-iii-hrc-filters",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1058-Zymo-Spin-III-HRC.jpg?v=1628532401&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iii-hrc-filters",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "Zymo-Spin IV-IR HRC Filters": {
            "title": "Zymo-Spin IV-IR HRC Filters",
            "catalogNumbers": "C1010-50",
            "description": "Component used in the OneStep PCR Inhibitor Removal kit (Cat. #D6031).",
            "handle": "/products/zymo-spin-iv-ir-hrc-filters",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/C1010-50_Zymo-Spin-IV-IR-HRC-Filter_600x.webp",
            "generalIndex": "998",
            "id": "zymo-spin-iv-ir-hrc-filters",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir": {
            "title": "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
            "catalogNumbers": "C1042-5",
            "description": "Available as a refill for the ZymoPURE Plasmid Maxiprep Kit. The versatile Zymo-Spin V-P with 15 ml conical and 50 ml reservoirs can be used in centrifuges or on-vacuum manifolds for the purification of plasmid DNA.",
            "handle": "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)": {
            "title": "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
            "catalogNumbers": "C1040-5",
            "description": "The versatile Zymo-Spin III-P with 15 ml conical and 50 ml reservoirs can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
            "handle": "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1040-5-Zymo-Spin-III-P.jpg?v=1628532396&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir": {
            "title": "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
            "catalogNumbers": "C1049-25",
            "description": "Features durable polypropylene construction and contains a unique silica-based matrix that allows purification of up to 5 µg of DNA in ≥ 35 µl eluate.",
            "handle": "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/3_20Zymo_20Spin_20IIIS.png?v=1628532405&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin V-E Columns": {
            "title": "Zymo-Spin V-E Columns",
            "catalogNumbers": "C1021-25, C1024-25, C1024-50, C1029-25",
            "description": "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
            "handle": "/products/zymo-spin-v-e-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1024-25-Zymo-Spin-VE.jpg?v=1628532394&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-v-e-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin VI Columns": {
            "title": "Zymo-Spin VI Columns",
            "catalogNumbers": "C1013-10, C1013-20",
            "description": "Column for recovery of up to 500 µg DNA or RNA in ≥ 2 ml.",
            "handle": "/products/zymo-spin-vi-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1013-10-Zymo-Spin-VI.jpg?v=1628532405&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-vi-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin VI Columns w/ Reservoir": {
            "title": "Zymo-Spin VI Columns w/ Reservoir",
            "catalogNumbers": "C1018-10, C1018-20",
            "description": "Column assembly for recovery of DNA/RNA from large volumes.",
            "handle": "/products/zymo-spin-vi-columns-w-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1018-Zymo-Spin-VI-with-Reservoir.jpg?v=1628532400&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-vi-columns-w-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin VI Columns w/ Zymo-Maxi Filter": {
            "title": "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
            "catalogNumbers": "C1017-10, C1017-20",
            "description": "Column-filter assembly for purifying DNA/RNA from ≤ 75 ml sample",
            "handle": "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg?v=1628532406&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-vi-columns-w-zymo-maxi-filter",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin VI-P Columns": {
            "title": "Zymo-Spin VI-P Columns",
            "catalogNumbers": "C1044-5",
            "description": "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
            "handle": "/products/zymo-spin-vi-p-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1044-5-Zymo-Spin-VI-P.jpg?v=1628532390&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-vi-p-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin I-96 Plate": {
            "title": "Zymo-Spin I-96 Plate",
            "catalogNumbers": "C2004, C2004-SW",
            "description": "Deep-well (96) plate purification of DNA/RNA in ≥ 10 µl elution.",
            "handle": "/products/zymo-spin-i-96-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2004-Zymo-Spin-I-96-Plate.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-i-96-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Zymo-Spin I-96-XL Plates": {
            "title": "Zymo-Spin I-96-XL Plates",
            "catalogNumbers": "C2010",
            "description": "The Zymo-Spin I-96-XL Plate can be used in centrifuges for the large-scale (i.e., 96-well) purification of high molecular weight DNA and/or RNA.",
            "handle": "/products/zymo-spin-i-96-xl-plates",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2010-Zymo-Spin-III-96-Plate.jpg?v=1628532395&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-i-96-xl-plates",
            "tags": [
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Zymo-Spin IV Columns": {
            "title": "Zymo-Spin IV Columns",
            "catalogNumbers": "C1007-50, C1007-250",
            "description": "The Zymo-Spin IV is a durable polypropylene filtration column that features a unique snap-off base and sealable orange screw cap.",
            "handle": "/products/zymo-spin-iv-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/c1007-50-zymo-spin-iv.jpg?v=1628532393&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iv-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin V Columns": {
            "title": "Zymo-Spin V Columns",
            "catalogNumbers": "C1012-25, C1012-50",
            "description": "The versatile Zymo-Spin V Fast-Spin column can be used either in microcentrifuges, centrifuges, or on vacuum manifolds for the purification of DNA and/or RNA.",
            "handle": "/products/zymo-spin-v-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1012-25-Zymo-Spin-V.jpg?v=1628532393&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-v-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Zymo-Spin V Columns w/ Reservoir": {
            "title": "Zymo-Spin V Columns w/ Reservoir",
            "catalogNumbers": "C1016-25, C1016-50",
            "description": "The Zymo-Spin V with Reservoir assembly can be used in conjunction with centrifuges and on vacuum manifolds for the purification of DNA and/or RNA.",
            "handle": "/products/zymo-spin-v-columns-w-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1016-25-Zymo-Spin-V-with-reservoir.jpg?v=1628532393&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-v-columns-w-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "Silicon-A Plate": {
            "title": "Silicon-A Plate",
            "catalogNumbers": "C2001",
            "description": "Shallow-well (96) plate purification of DNA/RNA in ≥ 30 µl.",
            "handle": "/products/silicon-a-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2001-Silicon-A-Plate.jpg?v=1628532407&width=600",
            "generalIndex": "998",
            "id": "silicon-a-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "plastics",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Zymo-Spin IB-96 Plate": {
            "title": "Zymo-Spin IB-96 Plate",
            "catalogNumbers": "C2006",
            "description": "Deep-well (96) plate for DNA clean-up & dye removal in ≥ 15 µl.",
            "handle": "/products/zymo-spin-ib-96-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2006-Zymo-Spin-IB-96-plate.jpg?v=1628532394&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-ib-96-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Silicon-A-HRC Plate": {
            "title": "Silicon-A-HRC Plate",
            "catalogNumbers": "C2009",
            "description": "Designed for efficient removal of polyphenolic compounds, humic/fulvic acids, tannins, melanin, etc. from most impure DNA and RNA preparations.",
            "handle": "/products/silicon-a-hrc-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2009-Silicon-A-HRC-Plate.jpg?v=1628532397&width=600",
            "generalIndex": "998",
            "id": "silicon-a-hrc-plate",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "plastics",
                "96-well-spin-plates"
            ],
            "filters": []
        },
        "Collection Plate": {
            "title": "Collection Plate",
            "catalogNumbers": "C2002",
            "description": "The 96-well Collection Plates feature deep-well, durable, clear polypropylene construction. Each has a level footprint and conforms to laboratory standards.",
            "handle": "/products/collection-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2002-Collection-Plate.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "collection-plate",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "Elution Plate": {
            "title": "Elution Plate",
            "catalogNumbers": "C2003",
            "description": "These clear polypropylene plates have a level footprint and conform to laboratory standards. Adaptable for use with either Silicon-A plates or Zymo-Spin I-96 filtration plates. Capacity is 90 µl per \"V\" bottom well.",
            "handle": "/products/elution-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2003-Elution-Plate.jpg?v=1628532403&width=600",
            "generalIndex": "998",
            "id": "elution-plate",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "ZR-96 BashingBead Lysis Rack": {
            "title": "ZR-96 BashingBead Lysis Rack",
            "catalogNumbers": "S6002-96-4, S6002-96-5",
            "description": "96-well microbial cell lysis rack for high throughput/automated bead beating",
            "handle": "/products/zr-96-bashingbead-lysis-rack",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6002_96_lysis_rack.jpg?v=1672171183&width=600",
            "generalIndex": "998",
            "id": "zr-96-bashingbead-lysis-rack",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "96-Well Block": {
            "title": "96-Well Block",
            "catalogNumbers": "P1001-2, P1001-10",
            "description": "96-Well Block features durable, clear polypropylene construction. Each has a level footprint and conforms to laboratory standards. Capacity is 2 ml per round bottom well.",
            "handle": "/products/96-well-block",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/P1001-2-96-well-block.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "96-well-block",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "Conversion Plate w/ Cover Foil": {
            "title": "Conversion Plate w/ Cover Foil",
            "catalogNumbers": "C2005",
            "description": "96-well, non-skirted PCR plate with alphanumeric labels.",
            "handle": "/products/conversion-plate-w-cover-foil",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2005-C2008-96-Well-Conversion-Plate.jpg?v=1628532402&width=600",
            "generalIndex": "998",
            "id": "conversion-plate-w-cover-foil",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "96-Well Block w/ Cover Foil": {
            "title": "96-Well Block w/ Cover Foil",
            "catalogNumbers": "P1002-2",
            "description": "2 ml, round bottom, 96-well block.",
            "handle": "/products/96-well-block-w-cover-foil",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/P1002-2-96-Well-block-with-cover-foil.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "96-well-block-w-cover-foil",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "96-Well Plate Cover Foil": {
            "title": "96-Well Plate Cover Foil",
            "catalogNumbers": "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
            "description": "Pierceable aluminum foil with strong adhesive strength for sealing 96-well plates and blocks.",
            "handle": "/products/96-well-plate-cover-foil",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2007_96-well_20Cover_20Foils.png?v=1628532408&width=600",
            "generalIndex": "998",
            "id": "96-well-plate-cover-foil",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "96-Well PCR Conversion Plate": {
            "title": "96-Well PCR Conversion Plate",
            "catalogNumbers": "C2008",
            "description": "96-well, non-skirted PCR plate with easy-to-read alphanumeric labels. Rimmed wells minimize cross contamination. Capacity is 200 µl per well.",
            "handle": "/products/96-well-pcr-conversion-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2008-96-well_pcr_conversion_plate.png?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "96-well-pcr-conversion-plate",
            "tags": [
                "96-well-plates"
            ],
            "filters": []
        },
        "MagBinding Beads": {
            "title": "MagBinding Beads",
            "catalogNumbers": "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8 ",
            "description": "For use with Zymo Research magnetic bead-based purification kits.",
            "handle": "/products/magbinding-beads",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4100-2-6_MagBinding-Beads-6-ml.jpg?v=1628532367&width=600",
            "generalIndex": "998",
            "id": "magbinding-beads",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "magbeads"
            ],
            "filters": []
        },
        "ZymoPURE Syringe Filters": {
            "title": "ZymoPURE Syringe Filters",
            "catalogNumbers": "C1036-5",
            "description": "The ZymoPURE Syringe Filter features durable polypropylene construction and novel filtration media that allows for rapid clarification of up to 60 ml of neutralized bacterial lysate using the supplied polypropylene plunger.",
            "handle": "/products/zymopure-syringe-filters",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1036-5-Syringe-Filters.jpg?v=1628532407&width=600",
            "generalIndex": "998",
            "id": "zymopure-syringe-filters",
            "tags": [
                "laboratory-equipment-and-supplies",
                "filters"
            ],
            "filters": []
        },
        "ZymoPURE Giga Filter": {
            "title": "ZymoPURE Giga Filter",
            "catalogNumbers": "C1038-1",
            "description": "The ZymoPURE Giga Filter features durable polypropylene construction and novel filtration media that allows for rapid clarification of up to 500 ml of neutralized bacterial lysate using a vacuum source.",
            "handle": "/products/zymopure-giga-filter",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1038-1_ZymoPURE-Giga-Filter.jpg?v=1664490074&width=600",
            "generalIndex": "998",
            "id": "zymopure-giga-filter",
            "tags": [
                "laboratory-equipment-and-supplies",
                "filters"
            ],
            "filters": []
        },
        "Spin-Away Filters": {
            "title": "Spin-Away Filters",
            "catalogNumbers": "C1006-50-F, C1006-250-F",
            "description": "The Spin-Away Filter can be used either in microcentrifuges or on vacuum manifolds for the purification of DNA and/or RNA.",
            "handle": "/products/spin-away-filters",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1006-50-F-Spin-Away-Filter.jpg?v=1628532396&width=600",
            "generalIndex": "998",
            "id": "spin-away-filters",
            "tags": [
                "laboratory-equipment-and-supplies",
                "filters"
            ],
            "filters": []
        },
        "ZRC GF Filter": {
            "title": "ZRC GF Filter",
            "catalogNumbers": "C1009-20, C1009-50",
            "description": "The ZRC-GF Filter syringe filter features durable polypropylene construction and contains a 1.6 µm pore size glass fiber filtration membrane.",
            "handle": "/products/zrc-gf-filter",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1009-20-ZRC-GF-Filter.jpg?v=1628532401&width=600",
            "generalIndex": "998",
            "id": "zrc-gf-filter",
            "tags": [
                "laboratory-equipment-and-supplies",
                "filters"
            ],
            "filters": []
        },
        "15 ml Conical Reservoir": {
            "title": "15 ml Conical Reservoir",
            "catalogNumbers": "C1031-25",
            "description": "The 15 ml Reservoir, used in conjunction with a luer-lock column, can be used for the purification of DNA and/or RNA.",
            "handle": "/products/15-ml-conical-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/15ml_20reservoir.png?v=1628532406&width=600",
            "generalIndex": "998",
            "id": "15-ml-conical-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "reservoirs"
            ],
            "filters": []
        },
        "25 ml Reservoir for Spin-Away Filters and Zymo-Spin": {
            "title": "25 ml Reservoir for Spin-Away Filters and Zymo-Spin",
            "catalogNumbers": "C1039-25",
            "description": "The 25 ml Reservoir, optimized for use with Spin-Away Filters and Zymo-Spin IIICG columns, can be used for the purification of DNA and/or RNA.",
            "handle": "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1039-25_Reservoir_20-_2025_20mL.png?v=1628532401&width=600",
            "generalIndex": "998",
            "id": "25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "reservoirs",
                "plastics",
                "spin-columns"
            ],
            "filters": []
        },
        "50 ml Conical Reservoir": {
            "title": "50 ml Conical Reservoir",
            "catalogNumbers": "C1032-25",
            "description": "The 50 ml Reservoir, used in conjunction with a luer-lock column, can be used with vacuum manifolds for the purification of DNA and/or RNA.",
            "handle": "/products/50-ml-conical-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1032-25-50ml-Conical-Reservoir.jpg?v=1628532404&width=600",
            "generalIndex": "998",
            "id": "50-ml-conical-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "reservoirs"
            ],
            "filters": []
        },
        "600 ml Reservoir": {
            "title": "600 ml Reservoir",
            "catalogNumbers": "C1033-5",
            "description": "The 600 ml Reservoir, used in conjunction with a luer-lock column, can be used with vacuum manifolds for the purification of DNA and/or RNA.",
            "handle": "/products/600-ml-reservoir",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1033-5-600-ml-Reservoir.jpg?v=1628532403&width=600",
            "generalIndex": "998",
            "id": "600-ml-reservoir",
            "tags": [
                "laboratory-equipment-and-supplies",
                "reservoirs"
            ],
            "filters": []
        },
        "Collection Tubes": {
            "title": "Collection Tubes",
            "catalogNumbers": "C1001-1000, C1001-50, C1001-500",
            "description": "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
            "handle": "/products/collection-tubes",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1001-Collection-Tube-2ml.jpg?v=1628532399&width=600",
            "generalIndex": "998",
            "id": "collection-tubes",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "plastics",
                "tubes"
            ],
            "filters": []
        },
        "DNase/RNase-Free Tubes": {
            "title": "DNase/RNase-Free Tubes",
            "catalogNumbers": "C2001-100, C2001-50",
            "description": "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
            "handle": "/products/dnase-rnase-free-tubes",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2001-100-DNase-RNase-free-tubes.jpg?v=1628532389&width=600",
            "generalIndex": "998",
            "id": "dnase-rnase-free-tubes",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "2.0 mL Clear Tubes, with caps": {
            "title": "2.0 mL Clear Tubes, with caps",
            "catalogNumbers": "C1025-50, C1025-500, C1027-50, C1027-500",
            "description": "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
            "handle": "/products/2-0-ml-clear-tubes-with-caps",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1025-Clear-Collection-Tube-2ml.jpg?v=1628532420&width=600",
            "generalIndex": "998",
            "id": "2-0-ml-clear-tubes-with-caps",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "2.0 mL Amber Tubes, with caps": {
            "title": "2.0 mL Amber Tubes, with caps",
            "catalogNumbers": "C1026-50, C1026-500, C1028-50, C1028-500",
            "description": "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
            "handle": "/products/2-0-ml-amber-tubes-with-caps",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1026-50-Amber-Tube-with-cap-2ml.jpg?v=1628532418&width=600",
            "generalIndex": "998",
            "id": "2-0-ml-amber-tubes-with-caps",
            "tags": [
                "laboratory-equipment-and-supplies"
            ],
            "filters": []
        },
        "DNA/RNA Shield Lysis & Collection Tubes": {
            "title": "DNA/RNA Shield Lysis & Collection Tubes",
            "catalogNumbers": "R1103, R1104, R1105, R1102",
            "description": "DNA/RNA Shield Lysis and Collection tubes are microbial lysis tubes and bead beating tubes designed for the streamlined collection, transport, and processing of biological specimen.",
            "handle": "/collections/lysis-tubes/products/dna-rna-shield-lysis-and-collection-tubes",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1103-DNA-RNA-Shield-Lysis-Tube-_Microbe.jpg?v=1628532366&width=600",
            "generalIndex": "998",
            "id": "dna-rna-shield-lysis-and-collection-tubes",
            "tags": [
                "lysis-tubes"
            ],
            "filters": []
        },
        "ZR Bashing Bead Lysis Tubes": {
            "title": "ZR Bashing Bead Lysis Tubes",
            "catalogNumbers": "S6003-50",
            "description": "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
            "handle": "/products/zr-bashing-bead-lysis-tubes",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
            "generalIndex": "998",
            "id": "zr-bashing-bead-lysis-tubes",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "plastics",
                "lysis-tubes"
            ],
            "filters": []
        },
        "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)": {
            "title": "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
            "catalogNumbers": "S6014-50",
            "description": "Each impact resistant 2 ml tube contains 0.7 ml (dry volume) mixed 0.1 & 2.0 mm BashingBeads.",
            "handle": "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
            "generalIndex": "998",
            "id": "zr-bashingbead-lysis-tubes-0-1-2-0-mm",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "plastics",
                "lysis-tubes"
            ],
            "filters": []
        },
        "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)": {
            "title": "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
            "catalogNumbers": "S6012-50",
            "description": "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
            "handle": "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
            "generalIndex": "998",
            "id": "zr-bashingbead-lysis-tubes-0-1-0-5-mm",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "plastics",
                "lysis-tubes"
            ],
            "filters": []
        },
        "ZR BashingBead Lysis/Filtration Tubes": {
            "title": "ZR BashingBead Lysis/Filtration Tubes",
            "catalogNumbers": "S6010, S6011",
            "description": "Each impact resistant 50 ml conical tube contains either 0.5mm or 2.0mm BashingBeads.",
            "handle": "/collections/lysis-tubes/products/zr-bashingbead-lysis-filtration-tubes",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6010_ZR-BashingBead-Lysis-Filtration-Tube---50-mL.jpg?v=1628532394&width=600",
            "generalIndex": "998",
            "id": "zr-bashingbead-lysis-filtration-tubes",
            "tags": [
                "lysis-tubes"
            ],
            "filters": []
        },
        "MagClearing Beads": {
            "title": "MagClearing Beads",
            "catalogNumbers": "D4100-1-10, D4100-1-20, D4100-1-40",
            "description": "MagClearing Beads are designed to be used with our Zyppy-96 Plasmid Miniprep kit, which use a pellet-free modified alkaline lysis method to isolate ultra-pure plasmid DNA from E. coli.",
            "handle": "/collections/lysis-tubes/products/magclearing-beads",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4100-1-10_MagClearing_20Beads_20-_2010_20mL.png?v=1628532358&width=600",
            "generalIndex": "998",
            "id": "magclearing-beads",
            "tags": [
                "lysis-tubes"
            ],
            "filters": []
        },
        "ZR-96 BashingBead Lysis Rack (Barcoded)": {
            "title": "ZR-96 BashingBead Lysis Rack (Barcoded)",
            "catalogNumbers": "S6002-96-4, S6002-96-5",
            "description": "The ZR-96 BashingBeadTM Lysis Rack (Barcoded) is a 96-well microbial lysis rack which enables complete homogenization/lysis of tough-to-lyse bacteria, fungi, yeast, and other cells.",
            "handle": "/collections/lysis-tubes/products/zr-96-bashingbead-lysis-rack-barcoded",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6002_96_lysis_rack.jpg?v=1672171183&width=600",
            "generalIndex": "998",
            "id": "zr-96-bashingbead-lysis-rack-barcoded",
            "tags": [
                "lysis-tubes"
            ],
            "filters": []
        },
        "Squisher-Single": {
            "title": "Squisher-Single",
            "catalogNumbers": "H1001, H1001-50",
            "description": "Disposable, single or multi-tube homogenizer.",
            "handle": "/products/squisher-single",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/H1001-Squisher-Single.jpg?v=1628532405&width=600",
            "generalIndex": "998",
            "id": "squisher-single",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "manual-homogenizers"
            ],
            "filters": []
        },
        "Squisher-96 w/ 96-Well Block": {
            "title": "Squisher-96 w/ 96-Well Block",
            "catalogNumbers": "H1004-2, H1004-5",
            "description": "Disposable, single or multi-tube homogenizer.",
            "handle": "/products/squisher-8-w-96-well-block",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/H1004-2-Squisher-96.jpg?v=1628532406&width=600",
            "generalIndex": "998",
            "id": "squisher-8-w-96-well-block",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-plates",
                "manual-homogenizers"
            ],
            "filters": []
        },
        "Squisher-8 w/ 96-Well Block": {
            "title": "Squisher-8 w/ 96-Well Block",
            "catalogNumbers": "H1002-5, H1002-20",
            "description": "Disposable, single or multi-tube homogenizer.",
            "handle": "/products/squisher-96-w-96-well-block",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/H1002-5-Squisher-8.jpg?v=1628532394&width=600",
            "generalIndex": "998",
            "id": "squisher-96-w-96-well-block",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "96-well-plates",
                "manual-homogenizers"
            ],
            "filters": []
        },
        "96-Well ELISA Plate": {
            "title": "96-Well ELISA Plate",
            "catalogNumbers": "C2020",
            "description": "96-well ELISA plate validated for use with the 5-mC ELISA and Quest 5-hmC ELISA kit.",
            "handle": "/products/96-well-elisa-plate",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C2020_96-well_20ELISA_20Plate.png?v=1628532398&width=600",
            "generalIndex": "998",
            "id": "96-well-elisa-plate",
            "tags": [
                "96-well-plates"
            ],
            "filters": []
        },
        "Zymo-Spin IICR Columns": {
            "title": "Zymo-Spin IICR Columns",
            "catalogNumbers": "C1078-50, C1078-250",
            "description": "Capped columns for the recovery of DNA and RNA in ≥ 25 µl.",
            "handle": "/products/zymo-spin-iicr-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1078_Zymo-Spin_20IICR_20Columns.png?v=1628532417&width=600",
            "generalIndex": "998",
            "id": "zymo-spin-iicr-columns",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "spin-columns"
            ],
            "filters": []
        },
        "EndoZero II Spin Columns": {
            "title": "EndoZero II Spin Columns",
            "catalogNumbers": "C1060-25",
            "description": "EndoZero II Spin-Columns are designed to be used with our ZymoPURE II Plasmid Midiprep Kit, which is the fastest and simplest method available to efficiently isolate up to 400 µg of endotoxin-free plasmid DNA from E. coli.",
            "handle": "/products/endozero-ii-spin-columns",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1060-25_EndoZero_20II_20Spin_20Columns.png?v=1628532420&width=600",
            "generalIndex": "998",
            "id": "endozero-ii-spin-columns",
            "tags": [
                "spin-columns"
            ],
            "filters": []
        },
        "Select-a-Size MagBead Set": {
            "title": "Select-a-Size MagBead Set",
            "catalogNumbers": "D4084-10, D4084-50",
            "description": "For use in Select-a-Size DNA Clean & Concentrator Magbead kit.",
            "handle": "/products/select-a-size-magbead",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4084-4-50_Select-a-Size-MagBead-50-ml_600x.jpg",
            "generalIndex": "998",
            "id": "select-a-size-magbead",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "magbeads"
            ],
            "filters": []
        },
        "ZymoBIOMICS MagBinding Beads": {
            "title": "ZymoBIOMICS MagBinding Beads",
            "catalogNumbers": "D4302-6-12, D4302-6-6",
            "description": "For use in ZymoBIOMICS magnetic bead-based purification kits.",
            "handle": "/products/zymobiomics-magbinding-beads",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4302-6-12_ZymoBIOMICS-MagBinding-Beads-12-ml.jpg?v=1628532363&width=600",
            "generalIndex": "998",
            "id": "zymobiomics-magbinding-beads",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "magbeads"
            ],
            "filters": []
        },
        "EZ-Methylation Magprep Beads": {
            "title": "EZ-Methylation Magprep Beads",
            "catalogNumbers": "D4100-5-4, D4100-5-8, D4100-5-16",
            "description": "For use in EZ-DNA Methylation Magprep bead-based purification kits.",
            "handle": "/products/ez-methylation-magprep-beads",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/EZ-MethylationMagprepBeads4ml_8710_5760x5760.jpg",
            "generalIndex": "998",
            "id": "ez-methylation-magprep-beads",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "magbeads"
            ],
            "filters": []
        },
        "MagBead J": {
            "title": "MagBead J",
            "catalogNumbers": "D4100-3-3, D4100-3-50, D4100-3-100",
            "description": "Optimized for low reaction volume workflows and high-throughput automation.",
            "handle": "/products/magbead-j",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/MagBeadJ3ml_8708_600x.jpg",
            "generalIndex": "998",
            "id": "magbead-j",
            "tags": [
                "laboratory-equipment-and-supplies",
                "magnetic-beads-and-spin-columns",
                "magbeads"
            ],
            "filters": []
        },
        "EZ-Vac 96 Vacuum Manifold": {
            "title": "EZ-Vac 96 Vacuum Manifold",
            "catalogNumbers": "S7003",
            "description": "The EZ-Vac 96 Vacuum Manifold is designed for the high-throughput, rapid parallel manual purification of nucleic acid using the ZymoPURE 96 Plasmid Miniprep Kit.",
            "handle": "/products/ez-vac-96-vacuum-manifold",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/S7003_EZ-Vac-96-Vacuum-Manifold.jpg?v=1689025787&width=600",
            "generalIndex": "998",
            "id": "ez-vac-96-vacuum-manifold",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "vacuum-manifolds"
            ],
            "filters": []
        },
        "EZ-Vac Vacuum Manifold": {
            "title": "EZ-Vac Vacuum Manifold",
            "catalogNumbers": "S7000",
            "description": "The EZ-Vac Vacuum Manifold is capable of processing up to 20 samples using vacuum pressure.",
            "handle": "/products/ez-vac-vacuum-manifold",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S7000_EZ-Vac-Vacuum-Manifold.jpg?v=1664490049&width=600",
            "generalIndex": "998",
            "id": "ez-vac-vacuum-manifold",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "vacuum-manifolds"
            ],
            "filters": []
        },
        "One-Way Luer-Lock Clear Stopcock": {
            "title": "One-Way Luer-Lock Clear Stopcock",
            "catalogNumbers": "S7001",
            "description": "Component for S7000: EZ-Vac Vacuum Manifold.",
            "handle": "/products/one-way-luer-lock-clear-stopcock",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S7001_One-way_20_20Luer-Lock_20Clear_20Stopcock.png?v=1628532366&width=600",
            "generalIndex": "998",
            "id": "one-way-luer-lock-clear-stopcock",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments"
            ],
            "filters": []
        },
        "Neoprene Stopper": {
            "title": "Neoprene Stopper",
            "catalogNumbers": "S7002",
            "description": "Component for sealing the EZ-Vac Vacuum Manifold (Cat. #S7000).",
            "handle": "/products/neoprene-stopper",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S7002_Neoprene_20Stopper.png?v=1628532354&width=600",
            "generalIndex": "998",
            "id": "neoprene-stopper",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments"
            ],
            "filters": []
        },
        "Elbow Hose Connector": {
            "title": "Elbow Hose Connector",
            "catalogNumbers": "S7004",
            "description": "The Elbow Hose Connector is a component for connecting vacuum tubing to the EZ-Vac Vacuum Manifold",
            "handle": "/products/elbow-hose-connector",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/S7004-Black-Elbow-Hose-Connector.jpg?v=1683050900&width=600",
            "generalIndex": "998",
            "id": "elbow-hose-connector",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments"
            ],
            "filters": []
        },
        "Vortex-Genie® 2": {
            "title": "Vortex-Genie® 2",
            "catalogNumbers": "S5001, S5002",
            "description": "The Vortex-Genie® 2 offers variable speed for precise mixing from gentle to vigorous, has hands-free or touch-on control, and may be used in cold rooms or incubators.",
            "handle": "/products/vortex-genie-2",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/vortex-genie-2_1_1.png?v=1628532357&width=600",
            "generalIndex": "998",
            "id": "vortex-genie-2",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "vortexers"
            ],
            "filters": []
        },
        "Digital Vortex-Genie® 2": {
            "title": "Digital Vortex-Genie® 2",
            "catalogNumbers": "S5003, S5004",
            "description": "The Digital Vortex-Genie® 2 has the same great features as Vortex-Genie® 2 with digital control and display of time.",
            "handle": "/products/digital-vortex-genie-2",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Digital_20Vortex-Genie.jpg?v=1628532370&width=600",
            "generalIndex": "998",
            "id": "digital-vortex-genie-2",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "vortexers"
            ],
            "filters": []
        },
        "Roto-Shake Genie®": {
            "title": "Roto-Shake Genie®",
            "catalogNumbers": "S5007, S5008",
            "description": "Combines rotating and rocking in one compact unit, the magnetic platform.",
            "handle": "/products/roto-shake-genie",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Roto-Shake_20Genie.jpg?v=1628532357&width=600",
            "generalIndex": "998",
            "id": "roto-shake-genie",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers",
                "shakers"
            ],
            "filters": []
        },
        "RotaPrep MegaLyser": {
            "title": "RotaPrep MegaLyser",
            "catalogNumbers": "S6021-3",
            "description": "The MegaLyser™ system delivers rapid, high-throughput sample lysis/homogenization across 96-deep well plate, 2 mL, 15 mL and 50 mL tube formats.",
            "handle": "/products/rotaprep-megalyser",
            "navigation_image": "https://stage.zymoresearch.com/cdn/shop/files/Megalyser-closed.png",
            "generalIndex": "998",
            "id": "rotaprep-megalyser",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers"
            ],
            "filters": []
        },
        "RotaPrep MonoLyser": {
            "title": "RotaPrep MonoLyser",
            "catalogNumbers": "S6021",
            "description": "The MonoLyser™ system is a sample lysis, homogenization and grinding system for life sciences applications like no other on the market.",
            "handle": "/products/rotaprep-monolyser",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/RotaPrep_20MonoLyser.jpg?v=1628532366&width=600",
            "generalIndex": "998",
            "id": "rotaprep-monolyser",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers"
            ],
            "filters": []
        },
        "Precellys® 24 Touch": {
            "title": "Precellys® 24 Touch",
            "catalogNumbers": "S6009-4",
            "description": "The Precellys® 24 Touch is a high-throughput tissue homogenizer capable of processing up to 24 samples in as little as 30 seconds.",
            "handle": "/products/precellys-24-touch",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-4.jpg?v=1660254499&width=600",
            "generalIndex": "998",
            "id": "precellys-24-touch",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers"
            ],
            "filters": []
        },
        "Cryolys® Evolution": {
            "title": "Cryolys® Evolution",
            "catalogNumbers": "S6009-5",
            "description": "The Cryolys® Evolution unit is designed to be used with the Precellys® Evolution (Cat. No. S6004-3) to keep the temperature of samples between 0 °C and 10 °C during homogenization. ",
            "handle": "/products/cryolys-evolution",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-5.jpg?v=1660255702&width=600",
            "generalIndex": "998",
            "id": "cryolys-evolution",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers"
            ],
            "filters": []
        },
        "FastPrep-96™": {
            "title": "FastPrep-96™",
            "catalogNumbers": "S6008",
            "description": "The FastPrep-96™ is a versatile high-speed homogenizer offering the ultimate in high-throughput sample preparation.",
            "handle": "/products/fastprep-96",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6008.jpg?v=1628532418&width=600",
            "generalIndex": "998",
            "id": "fastprep-96",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers"
            ],
            "filters": []
        },
        "FastPrep™ 24": {
            "title": "FastPrep™ 24",
            "catalogNumbers": "S6005, S6005-1, S6005-2, S6005-3, S6005-4, S6005-5, S6005-6",
            "description": "High-speed benchtop homogenizer that employs a powerful proprietary technology",
            "handle": "/products/fastprep-24",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6005ll.png?v=1628532422&width=600",
            "generalIndex": "998",
            "id": "fastprep-24",
            "tags": [
                "laboratory-equipment-and-supplies",
                "devices-and-instruments",
                "homogenizers"
            ],
            "filters": []
        },
        "Microtube Foam Inserts": {
            "title": "Microtube Foam Inserts",
            "catalogNumbers": "S5001-1",
            "description": "Two high-density foam inserts to accommodate up to 60 microtubes. For use with the Vortex-Genie 2 family of mixers and the Vortex-Genie Pulse. ",
            "handle": "/products/microtube-foam-inserts",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Microtube_20Foam_20Inserts.jpg?v=1628532352&width=600",
            "generalIndex": "998",
            "id": "microtube-foam-inserts",
            "tags": [
                "vortexers"
            ],
            "filters": []
        },
        "Microplate Foam Inserts": {
            "title": "Microplate Foam Inserts",
            "catalogNumbers": "S5001-2",
            "description": "Vortex-Genie Family Accessories, Foam Inserts",
            "handle": "/products/microplate-foam-inserts",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Microplate_20Foam_20Inserts.jpg?v=1628532367&width=600",
            "generalIndex": "998",
            "id": "microplate-foam-inserts",
            "tags": [
                "vortexers"
            ],
            "filters": []
        },
        "Tube Foam Inserts": {
            "title": "Tube Foam Inserts",
            "catalogNumbers": "S5001-3, S5001-8, S5001-",
            "description": "Vortex-Genie<sup>®</sup> Family Accessories, Foam Inserts",
            "handle": "/products/tube-foam-inserts",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Tube_20Foam_20Inserts.jpg?v=1628532366&width=600",
            "generalIndex": "998",
            "id": "tube-foam-inserts",
            "tags": [
                "vortexers"
            ],
            "filters": []
        },
        "Pop-off Cup": {
            "title": "Pop-off Cup",
            "catalogNumbers": "S5001-4",
            "description": "Mixing and vortexing in single tubes",
            "handle": "/products/pop-off-cup",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Pop-off_20Cup.jpg?v=1628532370&width=600",
            "generalIndex": "998",
            "id": "pop-off-cup",
            "tags": [
                "vortexers"
            ],
            "filters": []
        },
        "Horizontal Microtube Holder": {
            "title": "Horizontal Microtube Holder",
            "catalogNumbers": "S5001-5, S5001-6, S5001-7",
            "description": "Use with any Vortex-Genie<sup>®</sup> 2.",
            "handle": "/products/horizontal-microtube-holder",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/horizontal-_24_microtube_600x.png",
            "generalIndex": "998",
            "id": "horizontal-microtube-holder",
            "tags": [
                "vortexers"
            ],
            "filters": []
        }
    }
}